import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories, articles, faqs } from '@/mocks/data';

export default function Home() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 3);
  const latestArticles = articles.slice(0, 6);

  return (
    <>
      {/* Hero Section */}
      <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Two%20women%20silhouettes%20in%20soft%20embrace%2C%20flowing%20fabric%2C%20dramatic%20light%20rays%20from%20window%2C%20artistic%20fine%20art%20photography%2C%20warm%20amber%20and%20cream%20tones%2C%20ethereal%20atmosphere%2C%20soft%20focus%2C%20emotional%20depth%2C%20vintage%20literary%20aesthetic&width=1800&height=900&seq=home-hero-bg&orientation=landscape')`,
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
        <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 md:mb-6 max-w-4xl leading-tight">
            姐妹奴隶——深度情感羁绊与角色扮演创作指南
          </h1>
          <p className="text-base md:text-lg text-background-200/90 max-w-2xl mb-6 md:mb-8 leading-relaxed">
            探索人物关系构建、情感张力设计与剧情冲突技巧，帮助创作者打造引人入胜的姐妹羁绊故事
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-3 md:gap-4">
            <Link
              to="/category/character-relationship"
              className="px-6 md:px-8 py-3 rounded-full bg-accent-500 text-background-50 text-sm md:text-base font-medium hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              开始探索
            </Link>
            <Link
              to="/about"
              className="px-6 md:px-8 py-3 rounded-full border border-background-200/60 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/15 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </section>

      {/* Category Navigation */}
      <section className="w-full bg-background-50 py-12 md:py-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">创作分类导航</h2>
            <p className="text-foreground-600 text-sm md:text-base">选择你感兴趣的主题，深入探索姐妹羁绊的创作世界</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="group p-6 md:p-7 bg-background-50 border border-background-200/70 rounded-lg hover:border-accent-300 transition-all duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{cat.name}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">{cat.description}</p>
                <span className="text-xs text-foreground-400">{cat.articleCount} 篇文章</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Articles */}
      <section className="w-full bg-background-100 py-12 md:py-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-8 md:mb-10 gap-4">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">精选文章</h2>
              <p className="text-foreground-600 text-sm md:text-base">编辑推荐的深度好文，不容错过</p>
            </div>
            <Link
              to="/category/creative-writing"
              className="text-sm text-accent-600 hover:text-accent-700 font-medium transition-colors duration-200 flex items-center gap-1 whitespace-nowrap cursor-pointer"
            >
              查看全部 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {featuredArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full h-48 md:h-52 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium">
                      {article.categoryName}
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3 group-hover:text-accent-600 transition-colors duration-200 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">{article.excerpt}</p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <div className="flex items-center gap-3">
                      <span>{article.author}</span>
                      <span>{article.publishDate}</span>
                    </div>
                    <span>{article.readTime} 分钟阅读</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Latest Articles */}
      <section className="w-full bg-background-50 py-12 md:py-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-8 md:mb-10 gap-4">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">最新文章</h2>
              <p className="text-foreground-600 text-sm md:text-base">持续更新，为你带来更多创作灵感</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {latestArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-accent-300 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full h-44 md:h-48 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-xs text-accent-600 font-medium">{article.categoryName}</span>
                    <span className="text-xs text-foreground-400">{article.publishDate}</span>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-accent-600 transition-colors duration-200 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">{article.excerpt}</p>
                  <div className="flex items-center gap-2 flex-wrap">
                    {article.tags.slice(0, 3).map((tag) => (
                      <span key={tag} className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="w-full bg-background-100 py-12 md:py-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">常见问题</h2>
            <p className="text-foreground-600 text-sm md:text-base">你可能想了解的一些问题</p>
          </div>
          <div className="max-w-3xl mx-auto space-y-3">
            {faqs.map((faq, index) => (
              <details key={index} className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden cursor-pointer">
                <summary className="flex items-center justify-between p-5 font-heading text-foreground-800 font-medium text-sm md:text-base list-none">
                  {faq.question}
                  <span className="ml-4 flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400 group-open:hidden">
                    <i className="ri-add-line"></i>
                  </span>
                  <span className="ml-4 flex-shrink-0 w-6 h-6 hidden group-open:flex items-center justify-center text-foreground-400">
                    <i className="ri-subtract-line"></i>
                  </span>
                </summary>
                <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative w-full py-16 md:py-20 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20cozy%20reading%20nook%20with%20soft%20lamp%20light%2C%20open%20books%20on%20wooden%20table%2C%20steaming%20tea%20cup%2C%20vintage%20literary%20atmosphere%2C%20cream%20and%20amber%20color%20palette%2C%20fine%20art%20interior%20photography%2C%20soft%20focus%20background&width=1800&height=600&seq=home-cta-bg&orientation=landscape')`,
          }}
        ></div>
        <div className="absolute inset-0 bg-background-900/60"></div>
        <div className="relative z-10 w-full px-4 md:px-6 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">加入创作社区</h2>
          <p className="text-background-200/90 text-sm md:text-base mb-6 md:mb-8 max-w-xl mx-auto">
            订阅我们的创作通讯，第一时间获取最新文章、独家创作资源与社群活动信息
          </p>
          <a
            href="#newsletter"
            className="inline-block px-8 py-3 rounded-full bg-accent-500 text-background-50 text-sm md:text-base font-medium hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            立即订阅
          </a>
        </div>
      </section>

      {/* Newsletter Form */}
      <section id="newsletter" className="w-full bg-background-50 py-12 md:py-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-lg mx-auto text-center">
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-5">
              <i className="ri-mail-send-line text-2xl"></i>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">订阅创作通讯</h2>
            <p className="text-foreground-600 text-sm mb-6 leading-relaxed">
              每周获取精选创作指南、独家写作技巧与社群最新动态
            </p>
            <NewsletterForm />
          </div>
        </div>
      </section>
    </>
  );
}

function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errMsg, setErrMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setEmail('');
      return;
    }
    const formData = new FormData(form);
    if (!formData.get('email')?.toString().trim()) return;

    setStatus('loading');
    try {
      const res = await fetch('https://readdy.ai/api/form/d9rc5nue3oq4jqumtveg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(text); } catch { /* ignore */ }
      const code = (parsed as { code?: string })?.code;
      const msg = (parsed as { meta?: { message?: string } })?.meta?.message
        || (parsed as { message?: string })?.message
        || '';

      if (res.ok && code === 'OK') {
        setStatus('success');
        setEmail('');
      } else if (!res.ok || msg.includes('spam') || msg.includes('form data is spam')) {
        setStatus('error');
        setErrMsg(msg || '提交失败，请稍后重试');
      } else {
        setStatus('error');
        setErrMsg(msg || '提交失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setErrMsg('网络错误，请检查连接后重试');
    }
  };

  if (status === 'success') {
    return (
      <div className="p-6 bg-accent-100/50 rounded-lg text-center">
        <p className="text-accent-700 font-medium">感谢订阅！我们已收到你的邮箱，请留意查收确认邮件。</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} data-readdy-form="">
      <div className="flex flex-col sm:flex-row gap-3">
        <input
          type="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="输入你的邮箱地址"
          required
          className="flex-1 px-4 py-3 rounded-full border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-accent-400 transition-colors duration-200"
        />
        <button
          type="submit"
          disabled={status === 'loading'}
          className="px-6 py-3 rounded-full bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 disabled:opacity-60 transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          {status === 'loading' ? '提交中...' : '订阅'}
        </button>
      </div>
      {status === 'error' && (
        <p className="mt-3 text-sm text-red-600">{errMsg || '提交失败，请稍后重试'}</p>
      )}
      <div className="hp-field-wrapper">
        <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" readOnly aria-hidden="true" />
      </div>
    </form>
  );
}